module.exports = __webpack_public_path__ + "img/qr_han.961ea3fa.jpg";